import { PRODUCT_CATEGORY_WINE } from '@/consts/productConsts';
import { addIconToCountry } from '@/utils/location';
import {
  makeProductsUrlByCountry,
  makeProductsUrlByGrape,
  makeProductsUrlByTopic,
  makeProductsUrlByType,
  makeProductsUrlByWeight,
} from '@/utils/urlGenerator'

const WINE_TYPE_IMAGE = {
  'red wine': 'https://images.pexels.com/photos/5953601/pexels-photo-5953601.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=200',
  'white wine': 'https://images.pexels.com/photos/1123260/pexels-photo-1123260.jpeg?auto=compress&cs=tinysrgb&w=1260&h=200',
  'sparkling wine' : 'https://images.pexels.com/photos/5306741/pexels-photo-5306741.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=200',
  'rose wine' : 'https://images.pexels.com/photos/8459368/pexels-photo-8459368.jpeg?auto=compress&cs=tinysrgb&w=200',
};

export function generateCategoriesForProduct({product, minPriceInCents}) {
  if (!product) {
    return null;
  }
  const categories = [];
  
  if (product.type) {
    categories.push({
      cardImage: WINE_TYPE_IMAGE[product.type.toLowerCase()],
      cardText: product.type,
      url: makeProductsUrlByType(product.type, product.productCategory),
    })
  }
  if (product.features?.weight) {
    categories.push({
      cardImage: '',
      cardText: `${product.features.weight} Body`,
      url: makeProductsUrlByWeight(product.features.weight, product.productCategory),
    })
  }
  if (product.grape && product.grape.length < 20) {
    categories.push({
      cardImage: 'https://images.pexels.com/photos/357742/pexels-photo-357742.jpeg?auto=compress&cs=tinysrgb&w=200',
      cardText: product.grape,
      url: makeProductsUrlByGrape(product.grape, product.productCategory),
    })
  }

  const producer = product.producer;
  const country = producer?.location?.country  ? producer.location.country : 'USA';  
  categories.push({
    //cardImage: 'https://images.unsplash.com/photo-1562601579-599dec564e06?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=200',
    cardText: addIconToCountry(country),
    url: makeProductsUrlByCountry(country, product.productCategory),
  })

  if (product.productCategory === PRODUCT_CATEGORY_WINE) {

    if (minPriceInCents) {
      categories.push({
        cardImage: 'https://images.unsplash.com/photo-1562601579-599dec564e06?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=200',
        cardText: `Under $25`,
        url: makeProductsUrlByTopic('under_usd25', product.productCategory),
      })
    }

    
    if ((producer?.features?.esg || []).includes('Kosher')) {
      categories.push({
        cardImage: 'https://d1f01nqspnwjvc.cloudfront.net/vegancertjpg-106435.jpeg',
        cardText: `Kosher`,
        url: makeProductsUrlByTopic('Kosher', product.productCategory),
      })
    };

    categories.push({
      cardImage:
        'https://images.pexels.com/photos/887349/pexels-photo-887349.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=200',
      cardText: `Popular`,
      url: makeProductsUrlByTopic('Popular', product.productCategory),
    })
  }
  
  return categories;
}
